/**
 * An article's pages in its issue, from the admin fields firstPage / lastPage / pageCount
 * (pageCount is read from the PDF). Returns { first, last, total, range } with range like "17–21".
 */
export const getArticlePages = (article) => {
  const first = parseInt(article?.firstPage, 10) || 0;
  const count = parseInt(article?.pageCount, 10) || 0;
  let last = parseInt(article?.lastPage, 10) || 0;
  if (first && last < first) last = count ? first + count - 1 : first;
  const total = first ? last - first + 1 : count;
  const range = first ? (last > first ? `${first}–${last}` : String(first)) : '';
  return { first, last, total, range };
};

/** "pp. 17–21", "p. 1" or '' */
export const formatArticlePages = (article) => {
  const { range } = getArticlePages(article);
  if (!range) return '';
  return `${range.includes('–') ? 'pp.' : 'p.'} ${range}`;
};
